import {
  Component,
  OnInit,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { GlobalComponent } from "../../global/global.component";
import { ToastrService } from "ngx-toastr";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { IvrSettingBO, saveSettingsBO, SettingsBO } from "./agency-settings.modal";
import { AgencySettingsService } from "./agency-settings.service";
import { Clipboard } from "@angular/cdk/clipboard";
import { CommonApiService } from "src/app/commonapiservice";
import { DatePipe } from "@angular/common";
import { Guid } from "@syncfusion/ej2/pdf-export";
@Component({
  selector: "app-agency-settings",
  templateUrl: "./agency-settings.component.html",
  styleUrls: ["./agency-settings.component.scss"],
})
export class AgencySettingsComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  subject: Subject<boolean>;
  touched: boolean = false;
  isSaveorUpdateBoolean: boolean = false;
  setting: SettingsBO = new SettingsBO();
  savesetting : saveSettingsBO = new saveSettingsBO();
  logintype : string ;
  apiKey : string;
  btn1text: string;
  btn2text: string;
  IsWidgetKeyExpired : boolean = true;
  Id :string;
  ccxAccessKey : string ;
  outBoundCallFlowId : string  ;
  smsFlowId : string ;
  businessStartTime : string;
  businessEndTime : string;
  outBoundCallRetryDelay : string;
  outBoundMaxCallAttempts : string;
  SaveIvr : IvrSettingBO = new IvrSettingBO();

  constructor(
    public http: HttpClient,
    public global: GlobalComponent,
    public toastrService: ToastrService,
    public ASS: AgencySettingsService,
    private clipboard: Clipboard,
    public commonApi : CommonApiService,
     public datepipe: DatePipe
  ) {
    this.btn1text = "Copy";
    this.btn2text = "Copy";
   }
  ngOnInit() {
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == '' || this.global.globalAgencyId == undefined || this.global.globalAgencyId == 0||this.global.globalAgencyId=='00000000-0000-0000-0000-000000000000') {
      return;
    }

    this.logintype = localStorage.getItem("CFSS_checkType");
    this.getAgencySetting();
  }
  
  copyToClipboard() {
    this.clipboard.copy(this.apiKey);
    this.btn1text = "Copied";
    setTimeout(() => {
      this.btn1text = "Copy";
    }, 1000);
  }
  getAgencySetting() {
    let url;
    if(this.logintype =='onboardLogin')
      {
         url = "api/Client_Settings/getSettings?";
      }
      else{

         url = "api/Settings/getSettings?";
      }
    let myParams = new URLSearchParams();
    myParams.append("AgencyId", this.global.globalAgencyId)
    this.ASS
      .getSettings(myParams)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
       
        if(data!=null && data!=undefined && data!="")
        {
          this.setting = data;
          this.apiKey =  this.setting?.widgetAccessKeyBO?.accessKey;
          this.Id = this.setting?.widgetAccessKeyBO?.accessKey;
          this.IsWidgetKeyExpired  = (this.setting?.isWidgetKeyExpired );
          this.setting.widgetAccessKeyBO.expireDate = this.datepipe.transform(data?.widgetAccessKeyBO?.expireDate, "MM/dd/yyyy");
          this.SaveIvr = data;
          this.ccxAccessKey = data.ccxAccessKey;
          if(data.outBoundCallRetryDelay == null)
            this.SaveIvr.outBoundCallRetryDelay = 30;
          if(data.outBoundMaxCallAttempts == null)
            this.SaveIvr.outBoundMaxCallAttempts = 3;
          
        }
        else 
        {
          this.setting = new SettingsBO();
        }
      });
  }
 
  SaveOrUpdate() {
    this.isSaveorUpdateBoolean=true;
    var saveSettings: SettingsBO = JSON.parse(JSON.stringify(this.setting));
    var  savesetting : saveSettingsBO = JSON.parse(JSON.stringify(this.setting));
    if(!savesetting?.isCCXWidget)
    {
      this.apiKey = '';
      this.IsWidgetKeyExpired = true;
    }
    this.ASS
      .SaveSettings(savesetting)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: number) => {
          this.isSaveorUpdateBoolean=false;
          this.toastrService.success("Settings configured successfully!"),8000;
              // this.getAgencySetting();
              
           
        },
        (err: any) => {
          this.isSaveorUpdateBoolean=false;
          if (err) {
            this.toastrService.error(err.error, "Error"), 8000;
          }
        }
      );
  }
  generateApi(){
   this.ASS.generateApikey().pipe(takeUntil(this.onDestroy$)).subscribe(
    (data:any)=>{
      console.log(data);
      this.toastrService.success('API Key Generated Successfully');
      this.apiKey = data.accessKey;
      this.Id = data.accessKey;
      this.IsWidgetKeyExpired = false;
    },
    (err: any)=>{
      this.toastrService.error(err);
    }
   )
  }
  revokeApi(){
    this.apiKey = '';
    let url ='api/Settings/RevokeWidgetAccessKey?'
    let params = new URLSearchParams();
    params.append("AccessKey", this.Id );
    this.commonApi.saveorUpdateFunctionwithParams(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data:any)=>{
      this.IsWidgetKeyExpired = true;
      this.toastrService.success('API Key Revoked Successfully');
    },
  (err:any)=>{
    this.toastrService.error(err);
  })
  }
  isValidGuid(value): boolean {
    const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;
    return guidRegex.test(value);
  }
  SaveIvrConfiguration(){
    let url = "api/Settings/SaveOutboundIvrSettings";
    if(this.ccxAccessKey == null || this.ccxAccessKey == '' || this.ccxAccessKey == undefined){
      this.SaveIvr.ccxAccessKey = null;
    }
    else
    this.SaveIvr.ccxAccessKey = this.ccxAccessKey; 
    this.SaveIvr.ccxAccessKey = this.SaveIvr.ccxAccessKey?.trim();
    this.SaveIvr.outBoundCallFlowId = this.SaveIvr.outBoundCallFlowId?.trim();
    this.SaveIvr.smsFlowId = this.SaveIvr.smsFlowId?.trim();
    if(this.SaveIvr.outBoundCallFlowId == null || this.SaveIvr.outBoundCallFlowId == '' || this.SaveIvr.outBoundCallFlowId == undefined){
      this.SaveIvr.outBoundCallFlowId =  null ;
    }
    else{
      if(! this.isValidGuid(this.SaveIvr.outBoundCallFlowId)){
        this.toastrService.error("Invalid CallFlowId");
        return;
      }
    }
   if(this.SaveIvr.smsFlowId == null || this.SaveIvr.smsFlowId == '' || this.SaveIvr.smsFlowId == undefined){
      this.SaveIvr.smsFlowId =  null ;
    }
    else
    {
      if(! this.isValidGuid(this.SaveIvr.smsFlowId)){
        this.toastrService.error("Invalid SMS Flow ID");
        return;
      }
    }
    this.commonApi.saveorUpdateFunctionwithResponseTypeJson(this.SaveIvr , url).pipe(takeUntil(this.onDestroy$)).subscribe((data:any)=>{
      this.toastrService.success("IVR Configuration Saved Successfully");
      this.global.getAgencySetting();
    },
  (err : any)=>{
    this.toastrService.error(err);
  })
  }
  validateTime() {
    const startTime = this.SaveIvr.businessStartTime;
    const endTime = this.SaveIvr.businessEndTime;
  
    if (!startTime || !endTime) return; // skip if either is empty
  
    const start = this.parseTime(startTime);
    const end = this.parseTime(endTime);
   
    
    if (end <= start ) {
      this.toastrService.error("Business End Time must be greater than Start Time") ;
      this.SaveIvr.businessStartTime = '';
      this.SaveIvr.businessEndTime = '';
    }
    if(start < end)
      console.log(start,end);
      {
       if(end - start <= 15){
        this.toastrService.error("Business End Time should be 15 min greater than Start Time");
        this.SaveIvr.businessEndTime = '';
       }
      }
  }
  
  parseTime(timeStr: string): number {
    const [hours, minutes] = timeStr.split(':').map(Number);
    return hours * 60 + minutes;
  }
  validateRetryDelay(event: any) {
    if(isNaN(event.data))
      {
        this.SaveIvr.outBoundCallRetryDelay = null;
      }
      const value = event.target.value;
    console.log(event);
      // Restrict to 4 digits
      if (value.length > 4) {
        event.target.value = value.slice(0, 4);
      }
    
      // Update ngModel safely
      const numericValue = Number(event.target.value);
      if (numericValue > 1140) {
        this.SaveIvr.outBoundCallRetryDelay = 1140;
        event.target.value = '1140';
      } else {
        this.SaveIvr.outBoundCallRetryDelay = numericValue;
      }
  }
  
  validateMaxAttempts(event: any) {
    console.log(isNaN(event.data));
    if(isNaN(event.data))
      {
        this.SaveIvr.outBoundMaxCallAttempts = 1;
      }
      console.log(this.SaveIvr.outBoundMaxCallAttempts)
      const value = event.target.value;
      if (value.length > 1) {
        event.target.value = value.slice(0, 1);
      }
    
      // Update ngModel safely
      const numericValue = Number(event.target.value);
      if (numericValue > 5) {
        this.SaveIvr.outBoundMaxCallAttempts = 5;
        event.target.value = '5';
      } else {
        this.SaveIvr.outBoundMaxCallAttempts = numericValue;
      }
        
  }
  keyPress(event: any) {
    console.log(event,"keypress");
    const pattern = /[1-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  keyPressDelay(event: any) {
    console.log(event,"keypress");
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}

